import Chip from "@/components/Chip";
import Progress from "@/components/Progress/Progress";
import SimpleTable from "@/components/SimpleTable";
import { Button } from "@/components/ui/button";
import { Category } from "@/schema/app/assessment/category";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface CategoryTableProps {
  data: Category[];
}

function CategoryTable({ data }: CategoryTableProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div>
      <SimpleTable
        data={data}
        columns={[
          {
            key: "name",
            label: t("assessment-items"),
            render: ({ content }) => content,
          },
          {
            key: "status",
            label: t("status"),
            width: "200px",
            render: ({ is_answered }) => {
              return is_answered ? (
                <Chip label={t("completed")} />
              ) : (
                <Chip variant="warning" label={t("in-progress")} />
              );
            },
          },
          {
            key: "progress",
            label: t("progress"),
            width: "250px",
            render: ({ sub_category_count, completed_sub_category_count }) => {
              return (
                <Progress
                  total={sub_category_count}
                  completed={completed_sub_category_count}
                />
              );
            },
          },
          {
            key: "action",
            label: t("action"),
            width: "150px",
            render: ({ id, is_answered }, index) => {
              return index === 0 ? (
                <Button
                  variant="outline"
                  onClick={() => {
                    navigate(`/app/assessment/categories/${id}`)
                  }}
                >
                  {is_answered ? t("review") : t("answer")}
                </Button>
              ) : (
                <Button
                  variant="outline"
                  onClick={() => navigate(`/app/assessment/categories/${id}`)}
                >
                  {is_answered ? t("review") : t("answer")}
                </Button>
              );
            },
          },
        ]}
      />
    </div>
  );
}

export default CategoryTable;
